import { render } from "./header.vue?vue&type=template&id=28fce672&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=28fce672&scoped=true&lang=css"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fce672"]])

export default __exports__